module.exports = __webpack_public_path__ + "static/img/yuehui_zhang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/yuehui_zhang.jpg
// module id = cvvX
// module chunks = 0